import CustomSwitch from "components/Atoms/CustomSwitch"
import StringInput from "components/Atoms/StringInput"
import DynamicMultiSelector from "components/Molecules/DynamicMultiSelector"
import DynamicSelector from "components/Molecules/DynamicSelector"
import { ALL_SALESMAN } from "graphql/survey-areas/survey-areas.queries.gql"
import React from "react"
import useDCStore from "../dc.store"
import useDCRemoveM2M from "../useDCRemoveM2M"
import SurveyAreaPreviewMap from "./SurveyAreaPreviewMap"

type SurveyAreaRegistrationProps = {
  selectedArea?: any
  index: number
  area: any
}
const SurveyAreaRegistration = ({
  // 'selectedArea' object is local and only contains info that is required to keep track of the selected area (tab)
  selectedArea,
  // The 'area' variable is the actual state that changes and that is manipulated when sent to the server
  area,
  // dcAreas,
  // The current index of area
  index,
}: SurveyAreaRegistrationProps) => {
  const isSelected = area?.id === selectedArea?.id

  const onChange = useDCStore(store => store.setData("surveyAreas"))
  const { removeLink } = useDCRemoveM2M()
  if (!isSelected) return null

  const areaCatered = area?.areaCatered
  return (
    <>
      <div className="grid grid-cols-12 gap-4">
        <div className="col-span-6">
          <div className="grid grid-cols-12 gap-4">
            <div className="col-span-3 my-auto">
              <CustomSwitch path={`${index}.isActive`} label="Live" large />
            </div>
            <div className="col-span-9">
              <StringInput
                big={false}
                path={`${index}.name`}
                label="Name (Region)"
              />
            </div>
          </div>
        </div>
        <div className="col-span-6">
          <StringInput
            big={false}
            path={`${index}.codename`}
            label="Codename (Pincode)"
          />
        </div>
        <div className="col-span-6">
          <DynamicSelector
            path={`${index}.primaryUser`}
            label="Primary User"
            group="Salesman"
            query={ALL_SALESMAN}
            name={["fullName"]}
            labelElement="number"
            searchVector={["fullName", "number"]}
          />
        </div>
        <div className="col-span-6">
          <DynamicMultiSelector
            onDelete={user => {
              if (area?.id?.startsWith("vt")) return
              removeLink({
                fieldName: "users",
                fieldIds: [user.id],
                displayName: "Survey Area User",
                modelName: "vt_ecommerce.SurveyArea",
                modelId: area?.id,
              })
            }}
            fill
            path={`${index}.users`}
            label="Users"
            big={false}
            query={ALL_SALESMAN}
            renderText={(user: any) => user?.fullName}
            renderLabel={(user: any) => user?.number}
            renderTag={(user: any) => user?.fullName}
            searchBy={["fullName", "number"]}
          />
        </div>
      </div>
      <div style={{ height: "50vh", width: "100%" }}>
        <SurveyAreaPreviewMap
          enableDrawing
          onPolyComplete={(e: { coordinates: any }) => {
            onChange(`${index}.areaCatered`, e.coordinates)
          }}
          onRemove={() => {
            onChange(`${index}.areaCatered`, null)
          }}
          surveyAreaPolygon={areaCatered}
        />
      </div>
    </>
  )
}

export default SurveyAreaRegistration
